import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { AllocateSpotPointsToUsers } from '../../../redux/constants/apiConstants';
import SocialFeedsEmojiPicker from '../../SocialFeedsEmojiPicker';
import {
  InputContainer,
  StyledInputV2,
  StyledLabel,
} from "../../CreateEvent/style";
import { AdminCloseIcon, BrandingEmoji, SpotPointsGiftIcon } from '../../../utils/icons';
import { t } from 'i18next';
import { DescriptionContainer } from './CreateSpotPointForm';
import {  StyledModal,CalendarHeader,Border } from '../Rewards/styles';
import { showSuccessToast } from '../../UserDashboard/ToastHelper';


const CreateSpotPointsModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  //   onClose,
  companyInfo,
  fName,
  lName,
  // history,
  uid
  //   tierConfig,
}) =>{

  const [loading, setLoading] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [description, setDescription] = useState("");
  const [spotPoints, setSpotPoints] = useState(null);


  // const postCompanyRewardTier = async() =>{
  //   setLoading(true);
  //   const payload = {company_id:companyInfo.id, points:spotPoints,description}

  //   try {
  //     const companyRewardsData = await fetchApi(PostCompanyAdminRewardTierConfig , "POST",payload);
  //     if(companyRewardsData?.status === 'success'){
  //       history.push("/company/admin-rewards-management/dashboard");
  //       onCancel();
  //     }else{
  //       toast.error(companyRewardsData?.data?.message);
  //     }
  //   } catch (error) {
  //     toast.error(error);
      
  //   }finally{
  //     setLoading(false);
  //   }
  // }


  const handlePointsChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
  
    // allow empty
    if (!value) {
      setSpotPoints("");
      return;
    }
  
    // remove leading zeros
    value = value.replace(/^0+/, "");
  
    // limit to 5 digits
    value = value.slice(0, 5);
  
    setSpotPoints(value);
  };

  const SuccessToastMessage = (title, message) => {
    showSuccessToast(title , message, "383px");
  } 


  const postCompanyRewardTier = async () => {
    setLoading(true);
    const payload = {
      company_id: companyInfo.id,
      user_ids:[uid],
      points_per_recipient: Number(spotPoints),
      team_ids: [],
      department_ids: [],
      location_ids: [],
      description: description,
    }

    const apiUrl = AllocateSpotPointsToUsers;
    try {
      const res = await fetchApi(apiUrl, "POST", payload);
  
      if (res.status === "success") {
        // history.push("/company/people");
        // toast.success(res.message); 
        SuccessToastMessage("Spot Points Awarded!" ,`${fName} ${lName ? lName : ""} Has been Awarded with ${spotPoints} Spot Points.`, "383px");
        onCancel();
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
    finally{
      setLoading(false);
    }
  };

  const onChangeDescription=(e) => {
    const value = e.target.value;
  
    if ([...value].length <= 300) {
      setDescription(value);
    }
  }

  

  const onEmojiSelect = (emoji) => {
    const selectedEmoji = emoji?.native || emoji?.emoji || "";
  
    setDescription((prev) => {
      window.console.log("");
      return [...(prev + selectedEmoji)]
        .slice(0, 300)
        .join("");
    });
  
    setShowEmojiPicker(false);
  };


  const SelectPointTierLevels = () => {
    window.console.log("");
    
    return (
      <>
        <div className="formBody">
          <InputContainer>
            <StyledLabel isFont="16px" color="#184A61" margin={'16px'}>
              {t("Enter Spot Points")}
              {/* <span>*</span> */}
            </StyledLabel>
          
            <StyledInputV2
              placeholder={t("Enter Points")}
              name="number"
              value={spotPoints}
              onChange={handlePointsChange}
              // onChange={(e) =>{setSpotPoints(e.target.value)}}
              maxLength="5"
              bgColor="white"
              style={{ background: "white" }}
              pColor="#BDBDBD"
              color="#184A61"
              border="1px solid #DCDCDC"
              type="text"
              inputMode="numeric"
            />
          </InputContainer>

          <Border isBorder={"0.75px solid #EFEFEF"} style={{ margin: "20px 0 10px 0" }} />
          
          <StyledLabel isFont="16px" color="#184A61" margin={'20px'} marginb={'12px'} style={{float:'unset'}}>
          Explain Why You’re Awarding Spot Points
          </StyledLabel>
          <DescriptionContainer>
            <StyledInputV2
              as="textarea"
              height="48px"
              placeholder={t("Write what you’d like to say")}
              name="description"
              value={description}
              onChange={onChangeDescription}
              // onChange={(e) =>{setDescription(e.target.value)}}
              maxLength="300"
              bgColor="white"
              style={{ background: "white" }}
              pColor="#BDBDBD"
              color="#184A61"
              border="unset"
              isPadding="0px"
            />
          
            <div className="emoji-container">
              <div className='emojiIcon' onClick={()=>setShowEmojiPicker(true)}>
                {BrandingEmoji("#DA6C74")}
              </div>
              <div className='char-count'>
                {description?.length}/300 | C
              </div>
            </div>
          
          </DescriptionContainer>
          
         
          
          {showEmojiPicker ? <SocialFeedsEmojiPicker selectEmoji={onEmojiSelect} 
          // emojiRef={this.inputRef} 
            hidePicker={()=>setShowEmojiPicker(false)}></SocialFeedsEmojiPicker> : null}
        </div>
      </>
    );
  };
      
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div className="icon">{icon && icon}</div>
            <div>{title}</div>
          </div>
          <div className="close-icon" onClick={()=> onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border    isBorder={"0.75px solid #EFEFEF"}/>
  
      </div>
      {SelectPointTierLevels()}

      {/* <ConfirmPlanModalBody>

        {SelectPointTierLevels()}
      </ConfirmPlanModalBody> */}

      {/* <Border/> */}
  
      <div className='footer'>
        <CommonButtonPopup height="44px" width="300px" disabled={!spotPoints || !description || loading}  onClick={!spotPoints || !description || loading ? null : postCompanyRewardTier}>
          {SpotPointsGiftIcon(!spotPoints || !description || loading ?  "#989898" : "#ffffff")} Award Spot Points
        </CommonButtonPopup>
      </div>
    </StyledModal>
  )};


CreateSpotPointsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  uid:PropTypes.number,
  fName:PropTypes.string,
  lName:PropTypes.string,
};

export default withRouter((CreateSpotPointsModal));
  
